import { Badge, Tooltip } from "@mantine/core";
import { useEnergyDataWarnings } from "../../../hooks/energyData/useEnergyDataWarnings";

interface EnergyDataIndicatorProps {
  variantId: number;
  scope?: "menu" | "meters";
}

function EnergyDataIndicator({
  variantId,
  scope = "menu"
}: EnergyDataIndicatorProps) {
  const { data: energyDataWarnings } = useEnergyDataWarnings(variantId);

  if (!energyDataWarnings) {
    return null;
  }

  // switch case because more cases are to come (e.g. https://node-energy.atlassian.net/browse/D2-636)
  let numWarnings = 0;
  switch (scope) {
    case "menu": {
      numWarnings = energyDataWarnings.num_implausible_meters;
      break;
    }
    case "meters":
      numWarnings = energyDataWarnings.num_implausible_meters;
      break;
    default:
      break;
  }

  if (numWarnings === 0) {
    return null;
  }

  return (
    <Tooltip
      disabled={scope !== "meters"}
      label={`${numWarnings} ${numWarnings === 1 ? "Unplausibilität" : "Unplausibilitäten"} für das Stromsteuer-Meldejahr ${energyDataWarnings.reporting_year} gefunden.`}
    >
      <Badge
        className="EnergyDataIndicator"
        color="error"
        size="sm"
        style={
          scope === "menu"
            ? {
                position: "absolute",
                right: "calc(50% - 50px)",
                top: "10px"
              }
            : undefined
        }
      >
        {numWarnings}
      </Badge>
    </Tooltip>
  );
}

export { EnergyDataIndicator, EnergyDataIndicatorProps };
